<div *ngIf="aircraftEventSkeletonsLoading$ | async">Loading...</div>
<div *ngIf="aircraftEventSkeletonsLoaded$ | async">
  <ng-container *ngIf="aircraftEventTypes$ | async as aircraftEventTypes">
    <mat-accordion *ngIf="aircraftEventSkeletons$ | async as aircraftEventSkeletons">
      <mat-expansion-panel
        *ngFor="let aircraftEventSkeleton of aircraftEventSkeletons"
        (opened)="aircraftEventOpened(aircraftEventSkeleton)"
      >
        <mat-expansion-panel-header>
          {{ aircraftEventSkeleton.tailNumber }} -
          {{
            getAircraftEventTypeName(aircraftEventTypes, aircraftEventSkeleton.aircraftEventTypeId)
          }}
          from {{ aircraftEventSkeleton.startDateTimeUtc | momentDate | date : 'short' }} to
          {{ aircraftEventSkeleton.endDateTimeUtc | momentDate | date : 'short' }}
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <sd-portal-aircraft-event-audit-list
            #aircraftEventAuditList
            [aircraftEvent]="aircraftEventSkeleton"
            [loading]="
              (aircraftEventAuditsLoading$ | async) && (scheduledEventAuditsLoading$ | async)
            "
            [aircraftEventAudits]="aircraftEventAudits$ | async"
            [scheduledEventAudits]="scheduledEventAudits$ | async"
            [aircraftEventBusinessPersonLoading]="aircraftEventBusinessPersonAuditsLoading$ | async"
            [aircraftEventBusinessPersonAudits]="aircraftEventBusinessPersonAudits$ | async"
            [flightBusinessPersonTypes]="flightBusinessPersonTypes$ | async"
            (loadAircraftEvent)="loadAircraftEventAudits($event)"
            (loadScheduledEvent)="loadScheduledEventAudits($event)"
            (loadAircraftEventBusinessPerson)="loadAircraftEventBusinessPersonAudits($event)"
            (nextPage)="nextAircraftEventAuditPage($event)"
            (nextAircraftEventBusinessPersonPage)="nextAircraftEventBusinessPersonAuditPage($event)"
            (nextScheduledEventPage)="nextScheduledEventAuditPage($event)"
          >
          </sd-portal-aircraft-event-audit-list>
        </ng-template>
      </mat-expansion-panel>
    </mat-accordion>
  </ng-container>
</div>
